/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  progress(id) {
    return axios.get(`${this.url}/${id}/progress`);
  }

  previewFilter(payload, channel) {
    return axios.post(`${this.url}/preview_filter`, { payload, channel });
  }

  previewLabels(labelIds, channel) {
    return axios.post(`${this.url}/preview_labels`, {
      label_ids: labelIds,
      channel,
    });
  }

  previewCsv(blobSignedId, channel) {
    return axios.post(`${this.url}/preview_csv`, {
      blob_signed_id: blobSignedId,
      channel,
    });
  }

  testSend(campaignId, recipients) {
    return axios.post(`${this.url}/${campaignId}/test_sends`, { recipients });
  }
}

export default new CampaignsAPI();
